// extracted by mini-css-extract-plugin
export var closeIcon = "gated-modal-module--closeIcon--ItoGO";
export var gatedModalBox = "gated-modal-module--gatedModalBox--w7KIp";